<template>
  <div class="menu">
    <div class="logo">
      <a href="/"><img src="@/assets/H-json.svg" alt="聚合云助手" border="0"></a><span class="mainsite">&nbsp;&nbsp;<strong>|</strong>&nbsp;&nbsp;<a href="https://www.juhe.cn/?s=tool" target="_blank">聚合官网&nbsp;&gt;</a></span>
    </div>
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#2c2c2c"
      text-color="#cccccc"
      active-text-color="#3894ff">
      <el-menu-item index="/"><router-link to="/">JSON在线解析</router-link></el-menu-item>
      <el-submenu index="/encryption" @click="$router.push('/encryption/md5')">
        <template #title>加密/解密工具</template>
        <el-menu-item index="/encryption/md5"><router-link to="/encryption/md5">MD5加密</router-link></el-menu-item>
        <el-menu-item index="/encryption/sha"><router-link to="/encryption/sha">SHA加密</router-link></el-menu-item>
        <el-menu-item index="/encryption/desAes"><router-link to="/encryption/desAes">DES/AES加密解密</router-link></el-menu-item>
        <el-menu-item index="/encryption/rsa"><router-link to="/encryption/rsa">RSA公钥私钥加密解密</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="/parse" @click="$router.push('/parse/js')">
        <template #title>格式化/压缩工具</template>
        <el-menu-item index="/parse/js"><router-link to="/parse/js">JavaScript格式化/压缩工具</router-link></el-menu-item>
        <el-menu-item index="/parse/html"><router-link to="/parse/html">HTML格式化/压缩工具</router-link></el-menu-item>
        <el-menu-item index="/parse/css"><router-link to="/parse/css">CSS格式化/压缩工具</router-link></el-menu-item>
        <el-menu-item index="/parse/sql"><router-link to="/parse/sql">SQL格式化/压缩工具</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="/change" @click="$router.push('/change/hexbin')">
        <template #title>常用工具转换</template>
        <el-menu-item index="/change/hexbin"><router-link to="/change/hexbin">常用进制转换</router-link></el-menu-item>
        <el-menu-item index="/change/huoxingwen"><router-link to="/change/huoxingwen">简繁火星文转换</router-link></el-menu-item>
        <el-menu-item index="/change/pinyin"><router-link to="/change/pinyin">汉字转拼音</router-link></el-menu-item>
        <el-menu-item index="/change/rmb"><router-link to="/change/rmb">数字转人民币大写</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="/date" @click="$router.push('/date/stamp')">
        <template #title>时间转换</template>
        <el-menu-item index="/date/stamp"><router-link to="/date/stamp">时间戳转换</router-link></el-menu-item>
        <el-menu-item index="/date/calculation"><router-link to="/date/calculation">日期计算</router-link></el-menu-item>
      </el-submenu>
      <el-submenu index="/code" @click="$router.push('/code/base64')">
        <template #title>编码转换</template>
        <el-menu-item index="/code/base64"><router-link to="/code/base64">BASE64编码转换</router-link></el-menu-item>
        <el-menu-item index="/code/url"><router-link to="/code/url">URL编码/解码</router-link></el-menu-item>
        <el-menu-item index="/code/unicode"><router-link to="/code/unicode">Unicode中文互换</router-link></el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
    </el-menu>
    <!-- <li class="menu-item" v-for="(item, index) in routes" :key="index" :class="[active == item.meta.title ? 'active' : '']" @click="jump(item)">
      {{ item.meta.title }}
    </li> -->
  </div>
</template>

<script>
import { routes } from '@/router/index'
export default {
  data () {
    return {
      routes: routes,
      active: '',
      activeIndex: '1',
    }
  }
}
</script>

<style lang="stylus">
.menu
  width 1200px
  margin 0 auto
  height 60px
  line-height 60px
  color #fff
  display flex
  .logo
    margin-right 20px
  .logo .mainsite
    color #cccccc
    font-size 12px
  .menu-item
    font-size 14px
    margin-right 20px
    cursor pointer
  .active
    background-color #ecf5ff
    color #409eff

.el-menu-item
  a
    line-height 36px
    display inline-block
    width 100%
</style>
